import {Component, Input, OnInit} from '@angular/core';
import {
  faFaucet,
  faClock,
  faThermometerHalf,
  faPercent,
  faLeaf,
  faPauseCircle,
  faCircle,
  faCircleNotch, faAngleDoubleRight, faFile, faSun
} from '@fortawesome/free-solid-svg-icons';
import {IconDefinition} from '@fortawesome/fontawesome-common-types';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.css']
})
export class IconComponent implements OnInit {
  @Input()
  unit: string="";

  icon: IconDefinition = faFile;

  constructor() {
  }

  ngOnInit(): void {
    switch (this.unit) {
      case 'l/m2': {
        this.icon = faFaucet;
        break;
      }
      case 'min': {
        this.icon = faClock;
        break;
      }
      case '`C': {
        this.icon = faThermometerHalf;
        break;
      }
      case '%': {
        this.icon = faPercent;
        break;
      }
      case 'mS/cm': {
        this.icon = faCircleNotch;
        break;
      }
      case 'pH': {
        this.icon = faAngleDoubleRight;
        break;
      }

      case 'J/cm2': {
        this.icon = faSun;
        break;
      }


    }
  }

}
